export type FunctionOr<T> = T | ((v: T) => T);

export const unwrap = <T>(valueOrUpdater: FunctionOr<T>, currentState: T) =>
    valueOrUpdater instanceof Function ? valueOrUpdater(currentState) : valueOrUpdater;
